import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { WoOrderAttendantKpiList, WoOrderAttendantList } from 'src/app/models/sfc-order-attendant.model';
import { BasicChartList } from 'src/app/models/basic-chart.model';



@Injectable({
    providedIn: 'root'
  })

export class SfcWoOrderAttendantService{

    private environmentUrl: string = '';


    constructor(private httpClient: HttpClient)
    {
        this.environmentUrl = environment.ApiCore+'/Order/Attendant/';
    }

    getList() : Observable<WoOrderAttendantList>{
        let url = this.environmentUrl;
        return this.httpClient.get<WoOrderAttendantList>(url);
    }

    getKpi(): Observable<WoOrderAttendantKpiList> {
        let url = this.environmentUrl+ "Kpi";
        return this.httpClient.get<WoOrderAttendantKpiList>(url);
    }
s
    getChart(): Observable<BasicChartList> {
        let url = this.environmentUrl+ "ServiceChart";
        return this.httpClient.get<BasicChartList>(url);
    }



}


